// extracted by mini-css-extract-plugin
export var banner = "_2t-0";
export var icon = "_2t-1";
export var message = "_2t-2";